/* eslint-disable no-undef */
/// <reference path="../types/amap.d.ts" />
import dayjs from 'dayjs'
import CONFIG from '../constants/config'
import btnClose from '../images/btn_close_info_window.png'
import triangleImg from '../images/pathway/triangle_info_window.png'

export const loadGaodeSDK = (globalFuncName: string, callback: () => void) => {
  if (!!window.AMap) {
    callback()
  } else {
    window[globalFuncName] = callback
    let script = document.createElement('script')
    let uiScript = document.createElement('script')
    script.charset = 'utf-8'
    script.src =
      'https://webapi.amap.com/maps?v=2.0&key=348f768eed5b34b13c44ebccc532b7a6&plugin=AMap.ToolBar&callback=' +
      globalFuncName
    uiScript.src = 'https://webapi.amap.com/ui/1.1/main-async.js'
    document.body.appendChild(script)
    document.body.appendChild(uiScript)
  }
}

export const drawPathsV2 = ({
  pathways,
  checkedMembers,
  createInfoWindow,
  resetMapView = true
}) => {
  if (window.MapInstance) {
    window.MapInstance.clearMap()
    // pathways 和 checkedMembers 已经是普通数组
    const pathwaysJS = pathways
    const checkedMembersJS = checkedMembers
    let paths = pathwaysJS // 按用户划分路径
      .map((pathway) => {
        return {
          path: pathway['locations'].map((location) => {
            if (location['texts']['lng'] && location['texts']['lat']) {
              return new AMap.LngLat(
                location['texts']['lng'],
                location['texts']['lat']
              )
            } else {
              return null // 旧版本APP，没有上报经纬度
            }
          }),
          color:
            CONFIG.pathwayColors[
              checkedMembersJS.findIndex(
                (userID) => userID === pathway.userID
              )
            ]
        }
      })
    paths.forEach((pathObj, pathIndex) => {
      if (pathObj.path.length) {
        let markers: any[] = [],
          polylinePath: any[] = []
        pathObj.path.forEach((point, markerIndex) => {
          if (point) {
            // 过滤掉旧版本APP，没有上报经纬度的点
            const marker = new AMap.Marker({
              position: point,
              offset: new AMap.Pixel(0, -21),
              anchor: 'center',
              content: `
                    <div class="custom-marker">
                      <div class="screen" style="background-image: url(${
                        pathwaysJS[pathIndex].locations[markerIndex]?.photos[0]
                          ?.smallurl || ''
                      })">
                      ${
                        markerIndex === 0
                          ? `<div class="indicator-start"></div>`
                          : ''
                      }
                      ${
                        markerIndex === pathObj.path.length - 1 &&
                        markerIndex !== 0
                          ? `<div class="indicator-end"></div>`
                          : ''
                      }
                      </div>
                    </div>
                  `
            })
            marker.on('click', (e) => {
              const infoWindow = createInfoWindow(pathIndex, markerIndex)
              MapInfoWindow.setContent(infoWindow)
              window.MapInstance &&
                MapInfoWindow.open(window.MapInstance, e.target.getPosition())
            })
            markers.push(marker)
            polylinePath.push(point)
          }
        })
        if (markers.length && polylinePath.length) {
          window.MapInstance && window.MapInstance.add(markers)
          let polyline = new AMap.Polyline({
            path: polylinePath,
            strokeWeight: 7,
            strokeColor: pathObj.color,
            strokeOpacity: 1,
            borderWeight: 1,
            outlineColor: '#5B5C65',
            isOutline: true,
            lineJoin: 'round',
            showDir: true
          })
          window.MapInstance && window.MapInstance.add(polyline)
        }
      }
    })
    window.MapInstance && resetMapView && window.MapInstance.setFitView()
  } else {
    console.log('MapInstance is undefined')
  }
}

// 辅助函数：普通对象的属性访问
const getPathwayValue = (pathway, path) => {
  let value = pathway
  for (const key of path) {
    value = value?.[key]
    if (value === undefined) return undefined
  }
  return value
}

export const createLocationInfoWindowV2 = ({
  pathway,
  markerIndex,
  onButtonClick,
  onViewPhoto,
  canCheckDetail
}) => {
  // pathway 已经是普通对象
  const pathwayJS = pathway

  const infoWindow = document.createElement('div')
  infoWindow.className = 'custom-infoWindow'
  const title = document.createElement('div')
  title.className = 'title'
  title.innerHTML = `
    <div>
      <img src=${pathwayJS.headimgurl} alt="" class="avatar"/>
      <span>${pathwayJS.nickname}</span>
    </div>
  `
  const closeButton = document.createElement('img')
  closeButton.src = btnClose
  closeButton.className = 'close'
  closeButton.onclick = function () {
    window.MapInstance && window.MapInstance.clearInfoWindow()
  }
  title.appendChild(closeButton)
  const content = document.createElement('div')
  content.className = 'custom-infoWindow-content'

  const location = pathwayJS.locations?.[markerIndex]
  const photoTime = location?.photos?.[0]?.time
  const addr = location?.texts?.addr

  content.innerHTML = `
    <div class="time-address">
      <div>
        <label>时间：</label>
        <p>${dayjs.unix(photoTime).format(CONFIG.timeFormat)}</p>
      </div>
      <div>
        <label>地址：</label>
        <p>${addr}</p>
      </div>
    </div>
  `
  const photos = document.createElement('div')
  photos.className = 'photos'

  const locationPhotos = location?.photos || []
  const displayPhotos = locationPhotos.slice(0, 3)

  displayPhotos.forEach((photo, photoIndex) => {
    const photoElem = document.createElement('div')
    photoElem.className = 'photo'
    photoElem.style.backgroundImage = `url(${photo.smallurl})`
    if (locationPhotos.length > 3 && photoIndex === 2) {
      photoElem.innerHTML = `<div class="more"><span>更多</span><span>···</span></div>`
    }
    photoElem.onclick = () => onViewPhoto(photoIndex)
    photos.appendChild(photoElem)
  })
  content.appendChild(photos)

  if (canCheckDetail) {
    const button = document.createElement('button')
    button.innerText = '查看拍照路线详情'
    button.onclick = onButtonClick
    content.appendChild(button)
  }
  const triangle = document.createElement('img')
  triangle.className = 'triangle'
  triangle.src = triangleImg
  infoWindow.appendChild(title)
  infoWindow.appendChild(content)
  infoWindow.appendChild(triangle)
  return infoWindow
}

export const convertPoints = (points: any[]): Promise<any[]> => {
  let promises: Promise<any>[] = []
  const getPromise = function (chunk: any[]) {
    return new Promise(function (resolve, reject) {
      AMap.convertFrom(chunk, 'gps', function (status, result) {
        if (result.info === 'ok') {
          resolve(result.locations)
        } else {
          reject()
        }
      })
    })
  }
  for (let i = 0; i < points.length; i += 40) {
    const chunk = points.slice(i, i + 40)
    promises.push(getPromise(chunk))
  }
  return Promise.all(promises).then((results) => {
    return ([] as any[]).concat(...results)
  })
}

export const convertPoint = (photo) => {
  return new Promise(function (resolve, reject) {
    AMap.convertFrom(photo.point, 'gps', function (status, result) {
      if (result.info === 'ok') {
        resolve({
          ...photo,
          point: result.locations[0]
        })
      } else {
        reject()
      }
    })
  })
}
